require("./bootstrap");
require("bootstrap-datepicker");
require("bootstrap-datepicker/js/locales/bootstrap-datepicker.de.js");


